import { useEffect, useCallback, useRef } from 'react';

interface MenuItem {
  id: string;
  label: string;
}

const useScrollSync = (
  menuItems: MenuItem[],
  onMenuItemClick: (contentId: string) => void,
  isScrollingRef?: React.RefObject<boolean>
) => {
  const lastActiveRef = useRef<string>('');

  const handleScroll = useCallback(() => {
    // Skip scroll-sync during programmatic (sidebar-click) scrolling
    if (isScrollingRef?.current) return;

    for (let i = menuItems.length - 1; i >= 0; i--) {
      const section = document.getElementById(menuItems[i].id);
      if (section && section.getBoundingClientRect().top <= 150) {
        const newActive = menuItems[i].id;
        if (lastActiveRef.current !== newActive) {
          lastActiveRef.current = newActive;
          onMenuItemClick(newActive);
        }
        break;
      }
    }
  }, [menuItems, onMenuItemClick, isScrollingRef]);

  useEffect(() => {
    let ticking = false;
    const throttledScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', throttledScroll, { passive: true });
    return () => window.removeEventListener('scroll', throttledScroll);
  }, [handleScroll]);
};

export default useScrollSync;
